<div class="chat-container">
  <div class="chat-top">
    <div class="chat-title">Discussion</div>
    <div class="chat-sub-title">
      Create comments and attach bookmarks
      <span
        matTooltip="If you want BASF staff to be able to access all information of this project, feel free to share the project with your assigned support representative. Please note, that for all information exchanged within molded, confidentiality regulated in our Terms of Use automatically applies."
        class="bookmark-icon">
        !
      </span>
    </div>
  </div>
  <div class="chat-separator"></div>
  <div class="chat-middle" cdkScrollable #chatMessages>
    <div class="chat-messages">
      <ng-container *ngFor="let comment of comments; let i = index; let last = last">
        <mat-card
          class="chat-card {{ comment.editing === true || comment.replying === true ? 'no-cursor' : 'cursor' }}  {{
            comment.created_by.username === currentUser ? 'left-shift' : 'right-shift'
          }} {{comment.selected === true ? 'active-border' : 'no-border' }} ">
          <div class="comment-header">
            <span class="comment-name">{{ comment.created_by.full_name }}</span>
            <span class="comment-date">
              {{ comment.formatted_date }}
              <i *ngIf="comment.status === 'modified'">Edited</i>
            </span>

            <!-- *ngIf="comment.replies && comment.replies.length === 0" -->
            <button class="comment-menu" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu" (click)="cancelClickEvent($event)">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button [disabled]="comment.replies && comment.replies.length > 0" mat-menu-item (click)="showReplyForm($event, comment)">
                <span>Comment</span>
              </button>
              <button mat-menu-item [disabled]="!comment.editable || comment.created_by.username !== currentUser" (click)="editComment(comment)">
                <span>Edit</span>
              </button>
              <button mat-menu-item [disabled]="comment.replies.length > 0 || comment.created_by.username !== currentUser" (click)="deleteComment(comment)">
                <span>Delete</span>
              </button>
            </mat-menu>
            <!-- <div *ngIf="comment.replies && comment.replies.length > 0" class="invisible-div"></div> -->
          </div>

          <!-- add new component -->

          <!-- edit comment - show edit card -->

          <div *ngIf="comment.editing">
            <div class="bottom-container">
              <span
                [matMenuTriggerFor]="menuComment"
                class="color-rectangle extra-margin"
                [ngStyle]="{ 'background-color': comment.color }"
                (click)="cancelClickEvent($event)"></span>
              <mat-menu #menuComment="matMenu">
                <button (click)="changeCommentColor(comment, 'white')" mat-menu-item>
                  <span class="color-rectangle"></span>
                </button>
                <button (click)="changeCommentColor(comment, 'green')" mat-menu-item>
                  <span class="color-rectangle green"></span>
                </button>
                <button (click)="changeCommentColor(comment, 'orange')" mat-menu-item>
                  <span class="color-rectangle orange"></span>
                </button>
                <button (click)="changeCommentColor(comment, 'red')" mat-menu-item>
                  <span class="color-rectangle red"></span>
                </button>
              </mat-menu>

              <mat-icon (click)="enablePicker($event, commentTypeEnum.CURRENT, i)" class="add-location-icon add-secondary"> add_location </mat-icon>

              <ng-container *ngFor="let chunk of getAnnos(comment) | chunk : 5; let j = index">
                <div class="icon-row" style="display: flex">
                  <ng-container *ngFor="let anno of chunk; let i = index">
                    <div class="icon-container">
                      <mat-icon
                        (click)="selectAnnotation($event, i + 5 * j, comment)"
                        (contextmenu)="deleteAnnotation(i + 5 * j, comment)"
                        class="add-location-icon {{ anno.selected == true ? 'selected' : 'not-selected' }}">
                        add_location
                      </mat-icon>
                    </div>

                    <ng-container *ngIf="(i + 1) % 5 === 0 && i < chunk.length - 1"><br /></ng-container>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>

          <!-- ##end## -->

          <!-- no edit mode-->
          <mat-card-content *ngIf="!comment.editing">
            <div style="display: inline-block" *ngIf="comment.color !== 'white'">
              <span style="margin-right: 5px" class="color-rectangle right-margin" [ngStyle]="{ 'background-color': comment.color }" (click)="cancelClickEvent($event)"></span>
            </div>

            <div style="display: inline-block">
              <mat-icon *ngIf="isAnnos(comment)" class="add-location-icon add-secondary">add_location</mat-icon>
            </div>
            <!-- chat content -->
            <p (click)="selectComment(comment)" class="comment">
              {{ comment.content }}
            </p>
          </mat-card-content>
          <mat-card-content *ngIf="comment.editing">
            <mat-form-field (click)="cancelClickEvent($event)" style="width: 100%">
              <textarea
                matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="20"
                [ngModel]="comment.content"
                #commentTextarea></textarea>
            </mat-form-field>
            <button mat-raised-button class="blue-button" (click)="updateComment($event, comment, commentTextarea.value)">Save</button>
          </mat-card-content>

          <div *ngIf="comment.replies && comment.replies.length > 0">
            <hr class="reply-seperator" />
            <div *ngFor="let reply of comment.replies; let last = last">
              <div class="comment-header">
                <span class="comment-name">{{ reply.created_by.full_name }}</span>
                <span class="comment-date">
                  {{ reply.formatted_date }}
                  <i *ngIf="reply.status === 'deleted'">Deleted</i>
                  <i *ngIf="reply.status === 'modified'">Edited</i>
                </span>
                <button class="comment-menu" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item [disabled]="!last" (click)="showReplyForm($event, comment)">
                    <span>Submit</span>
                  </button>
                  <button mat-menu-item [disabled]="!reply.editable || reply.status === 'deleted' || reply.created_by.username !== currentUser" (click)="editReply(reply)">
                    <span>Edit</span>
                  </button>

                  <button mat-menu-item [disabled]="reply.status === 'deleted' || reply.created_by.username !== currentUser" (click)="deleteReply(reply)">
                    <span>Delete</span>
                  </button>
                </mat-menu>
                <!-- <div *ngIf="!last" class="invisible-div"></div> -->
              </div>
              <mat-card-content *ngIf="!reply.editing">
                <p *ngIf="reply.status !== 'deleted'" (click)="selectComment(comment)" class="reply">
                  {{ reply.content }}
                </p>
                <p *ngIf="reply.status === 'deleted'"><i>reply deleted...</i></p>
              </mat-card-content>
              <mat-card-content *ngIf="reply.editing">
                <mat-form-field style="width: 100%">
                  <textarea
                    matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="20"
                    [(ngModel)]="reply.content"
                    #replyTextarea></textarea>
                </mat-form-field>
                <button mat-raised-button class="blue-button" (click)="updateReply($event, reply, replyTextarea.value)">Save</button>
              </mat-card-content>
              <hr *ngIf="!last" />
            </div>
          </div>
          <div *ngIf="comment.replying">
            <mat-form-field class="chat-input custom-width" style="--form-width: 80%">
              <input matInput placeholder="Your message" [(ngModel)]="comment.reply_content" />
            </mat-form-field>
            <button mat-raised-button class="blue-button" (click)="addReply($event, comment)">Submit</button>
          </div>
        </mat-card>
        <!-- <hr *ngIf="!last" /> -->
      </ng-container>
    </div>
  </div>
  <div class="chat-separator"></div>

  <!-- bottom container -->

  <div class="chat-bottom">
    <div class="chat-input-container">
      <div class="bottom-container">
        <span [matMenuTriggerFor]="menu" class="color-rectangle border left-margin" [ngStyle]="{ 'background-color': selectedColor }" (click)="cancelClickEvent($event)"></span>
        <mat-menu #menu="matMenu">
          <button (click)="selectedColor = 'white'" mat-menu-item><span class="color-rectangle border"></span></button>
          <button (click)="selectedColor = '#66af89'" mat-menu-item><span class="color-rectangle green"></span></button>
          <button (click)="selectedColor = '#f6af40'" mat-menu-item>
            <span class="color-rectangle orange"></span>
          </button>
          <button (click)="selectedColor = '#d34059'" mat-menu-item><span class="color-rectangle red"></span></button>
        </mat-menu>

        <mat-icon *ngIf="isAnnotationMode" (click)="enablePicker($event, commentTypeEnum.NEW, -1)" class="add-location-icon add"> add_location </mat-icon>

        <div>
          <ng-container *ngFor="let chunk of currentAnnos | chunk : 5; let j = index">
            <div class="icon-row">
              <ng-container *ngFor="let anno of chunk; let i = index">
                <mat-icon
                  (click)="selectAnnotation($event, i + 5 * j)"
                  (contextmenu)="deleteAnnotation(i + 5 * j)"
                  class="add-location-icon {{ i + 5 * j === selectedAnno ? 'selected' : 'not-selected' }}">
                  add_location
                </mat-icon>
                <ng-container *ngIf="(i + 1) % 5 === 0 && i < chunk.length - 1"><br /></ng-container>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>

      <mat-form-field class="chat-input">
        <input matInput placeholder="Your message" (mouseup)="deselectComment()" [(ngModel)]="newComment" data-cy="comment_message" />
      </mat-form-field>
      <button mat-raised-button class="blue-button" (click)="comment()" data-cy="submit_comment">Submit</button>
    </div>
  </div>
</div>
